export const externalCustomersSearchMock = [
  {
    source: 'autostacja',
    externalId: '16597',
    discriminator: 'BUSINESS',
    businessAddress: {
      street: 'Górna',
      descriptiveNumber: '24',
      orientationNumber: '16',
      city: 'Gostyń',
      zip: '63-800',
      country: 'POL',
      prefix: 'ul.',
      postal: 'Gostyń',
    },
    vatNumber: '3434200013',
    registrationNumber: '705775750',
    tradeName: 'FELICJAN GOKCEN',
    foundingPerson: {
      email: 'FIRMA16597@XX.pl',
      phone: '251331353',
    },
  },
  {
    source: 'autostacja',
    externalId: '16758',
    discriminator: 'BUSINESS',
    businessAddress: {
      street: 'Plac Berwińskiego',
      descriptiveNumber: '16',
      orientationNumber: null,
      city: 'Zaniemyśl',
      zip: '63-020',
      country: 'POL',
      prefix: 'pl.',
      postal: null,
    },
    vatNumber: '2534301055',
    registrationNumber: '705737170',
    tradeName: 'JANIS MAUCHAN',
    foundingPerson: {
      email: 'FIRMA16758@XX.pl',
      phone: '001120011',
    },
  },
];
